import { render } from "./technologyOfflineInfo.vue?vue&type=template&id=b7a5b10c&scoped=true"
import script from "./technologyOfflineInfo.vue?vue&type=script&lang=js"
export * from "./technologyOfflineInfo.vue?vue&type=script&lang=js"

import "./technologyOfflineInfo.vue?vue&type=style&index=0&id=b7a5b10c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7a5b10c"]])

export default __exports__